import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';

type TenantNewTermSchoolClassState = {
    isLoading: boolean;
    data: TenantNewTermSchoolClass | undefined;
};

export const useViewTenantNewTermSchoolClass = () => {
    const [state, setState] = useState<TenantNewTermSchoolClassState>({
        isLoading: false,
        data: undefined,
    });

    const tenantNewTermSchoolClassSettingControlViewConnection = useAppSelector(
        (state) => state.tenantNewTermSchoolClassSettingControlViewConnection
    );

    const tenantNewTermSchoolClassSettingViewConnection = useAppSelector(
        (state) => state.tenantNewTermSchoolClassSettingViewConnection
    );

    const dispatch = useDispatch();

    useEffect(() => {
        const { meta, payload } = tenantNewTermSchoolClassSettingControlViewConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                setState({
                    data: dataConvert(payload.result),
                    isLoading: false,
                });
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setState((state) => ({
                    ...state,
                    isLoading: false,
                }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantNewTermSchoolClassSettingControlViewConnection]);

    useEffect(() => {
        const { meta, payload } = tenantNewTermSchoolClassSettingViewConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                setState({
                    isLoading: false,
                    data: dataConvert(payload.result),
                });
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setState((state) => ({
                    ...state,
                    isLoading: false,
                }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantNewTermSchoolClassSettingViewConnection]);

    const request = useCallback(
        (isControllableUser = false) => {
            isControllableUser
                ? dispatch(Actions.http.connection.tenantNewTermSchoolClassSetting.controlView())
                : dispatch(Actions.http.connection.tenantNewTermSchoolClassSetting.view());

            setState((state) => ({
                ...state,
                isLoading: true,
            }));
        },
        [dispatch]
    );

    const reset = useCallback(() => {
        setState((state) => ({
            ...state,
            isLoading: false,
        }));
    }, []);

    return [state, request, reset] as const;
};

type ResponseResult =
    | Http.Connection.Response.TenantNewTermSchoolClassSetting.Control.View['result']
    | Http.Connection.Response.TenantNewTermSchoolClassSetting.Admin.View['result'];

const dataConvert = (tenantNewTermSchoolClassSetting: ResponseResult): TenantNewTermSchoolClass => {
    return {
        uuid: tenantNewTermSchoolClassSetting.uuid,
        visibilityTiming: tenantNewTermSchoolClassSetting.visibility_timing,
        visibilityScheduledMonth: tenantNewTermSchoolClassSetting.visibility_scheduled_month,
        visibilityScheduledDay: tenantNewTermSchoolClassSetting.visibility_scheduled_day,
        createdAt: tenantNewTermSchoolClassSetting.created_at,
        updatedAt: tenantNewTermSchoolClassSetting.updated_at,
        canAdminUpdateVisibility: tenantNewTermSchoolClassSetting.can_admin_update_visibility,
        overwriteAdminVisibilitySchedules: tenantNewTermSchoolClassSetting.overwrite_admin_visibility_schedules,
    };
};
